import type { AssistantInfo } from "../../../services/api/instances/assistantsApi/types";
import type { ChatCompletionsMessageObject } from "../../../services/api/instances/completionsApi/types";
import type { DialogValue } from "../../../services/api/instances/dialogApi/types";
import type { OutputMessageType } from "../../../services/api/instances/responseApi/types/common";
import type { TResponseThread } from "../../../services/api/instances/responseApi/types/response";
import type { MessageList } from "../../../services/api/methodsTypes";
import { hiddenSecurityPart } from "../../../shared/utils/hiddenSecurityPart";

export const getFilteredAssistants = (assistants: AssistantInfo[]) => {
  const filteredAssistants = assistants.filter((assistant) => {
    return assistant.metadata?.dialogs === "true";
  });
  return filteredAssistants;
};

export const transformMessagesObject = (
  messages: TResponseThread,
): ChatCompletionsMessageObject[] => {
  return messages.reduce((acc, obj) => {
    const assistantMessage = obj.output.output.at(-1) as OutputMessageType;
    const assistantText = assistantMessage.content?.at(-1)?.text;

    return [
      ...acc,
      { role: "user", content: hiddenSecurityPart(obj.input.input) },
      { role: "assistant", content: assistantText as string },
    ];
  }, [] as ChatCompletionsMessageObject[]);
};

export function transformMessageListToChatCompletions(
  messageList: MessageList,
): ChatCompletionsMessageObject[] {
  return messageList.data.map((message) => {
    const contentText = message.content
      .filter((item) => item.type === "text")
      .map((item) => item.text.value)
      .join("\n");

    return {
      role: message.role,
      content: contentText || null,
    };
  });
}

export const mergedDialogMessages = (
  oldMessages: ChatCompletionsMessageObject[],
  receivedMessages: ChatCompletionsMessageObject[],
) => {
  const oldLength = oldMessages?.length;
  const receivedLength = receivedMessages?.length;

  if (oldLength === receivedLength) {
    return receivedMessages;
  }
  return [...oldMessages, ...receivedMessages.slice(oldLength)];
};

export const addUserMessage = (
  objectForUpdate: DialogValue,
  userMessage: string,
): DialogValue => {
  const newDialogObject = objectForUpdate?.dialog_object
    ? {
        ...objectForUpdate?.dialog_object,
        messages: [
          ...objectForUpdate?.dialog_object?.messages,
          { role: "user", content: userMessage },
        ],
      }
    : undefined;

  return {
    ...objectForUpdate,
    dialog_object: newDialogObject,
  };
};
